import { createAction } from '@ngrx/store';
import { SsrFlowExitReason } from '../../../models/monitoring/SsrFlowExitReason';
import { SsrActionType } from '../../../models/monitoring/SsrActionType';
import { ssrMetricsFeatureKey } from './ssr-metrics.state';

export const initializeSsrMetricsState = createAction(`[${ssrMetricsFeatureKey}] Initialize SsrMetrics state`);

/**
 * Action for setting starting attributes for SsrMetrics via the ReservationDropdown or AddAnotherSsr button on SsrSummary page
 */
export const startSsrMetrics = createAction(
  `[${ssrMetricsFeatureKey}] Start SsrMetrics`,
  (actionType: SsrActionType, timestampMillis: number, confirmationCode: string) => ({
    actionType,
    timestampMillis,
    confirmationCode,
  })
);

/**
 * Action for setting the ssrCode that the user selects
 */
export const setSsrMetricsSsrCode = createAction(`[${ssrMetricsFeatureKey}] Set SsrMetrics SsrCode`, (ssrCode: string | undefined) => ({
  ssrCode,
}));

/**
 * Action for completing the SsrMetrics via the Continue or AddAnotherSsr buttons on SsrSummary page
 */
export const completeSsrMetrics = createAction(`[${ssrMetricsFeatureKey}] Complete SsrMetrics`, (exitReason: SsrFlowExitReason) => ({
  exitReason,
}));

/**
 * Action for resetting attributes of the SsrMetrics to null in the store
 */
export const clearSsrMetrics = createAction(`[${ssrMetricsFeatureKey}] Clear SsrMetrics attributes`);
